module.exports = __webpack_public_path__ + "img/cherry-no-messages.c196ee8f.png";